import React, { useState } from "react";
import ReactModal from "react-modal";

import { color_black, color_grey_light, color_red_active, color_white, color_red_default, color_black_ultra_light, color_grey_dark } from "../../constants/colors";
import RadioBoxEmpty from "../controls/check-boxes/RadioBoxEmpty";
import { OnestNormalSmall, OnestBoldSmall, OnestBoldDefault  } from "../styled/TextComponents";
import { useWindowDimensions } from "../../utils";

import { Button } from '../../components/controls/Button/Button';
import { useI18n } from "../../i18n/I18nProvider";

const ModalTarifChange = ({
    isOpen,
    onClose,
    userData,
    currentTarif,
    setNewTarif,
}) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                content: {
                    backgroundColor: color_white,
                    borderRadius: "16px",
                    width: screenWidth > 420 ? "270px" : `${screenWidth - 120}px`,
                    height: "420px",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    padding: "20px",
                    gap: "10px",
                    inset: screenWidth > 460 ? "40px" : `calc(50vw - ${screenWidth - 120 / 2}px)`,

                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "hidden",
                    zIndex: 1000,
                },
            }}
        >
            <OnestBoldDefault>{t("Изменение тарифа")}</OnestBoldDefault>
            <OnestBoldSmall style={{ marginTop: "10px", }}>
                {t("Teкущий тариф: ")}{currentTarif === "m" ? t("Месячный") : t("Годовой")} {t("план")}
            </OnestBoldSmall>
            <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                {t("Вы можете перейти на ")}{currentTarif === "m" ? t("Годовой") : t("Месячный")}  {t("план.")}
            </OnestNormalSmall>
            <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                {t("Новый тариф активируется после окончания оплаченного периода по текущему")}
            </OnestNormalSmall>
            <div style={{
                position: "relative",
                borderRadius: 20,
                borderWidth: 1,
                borderStyle: "solid",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
                alignSelf: "center",
                padding: 20,
                gap: 10,
                width: screenWidth > 420 ? "220px" : `${screenWidth - 200}px`,
                height: 155,
                borderColor: color_grey_light,

            }}>

                <OnestBoldSmall>{currentTarif === "m" ? t("Годовой") : t("Месячный")} {t("план")}</OnestBoldSmall>
                <OnestBoldDefault
                    style={{
                        color: color_black,
                        fontSize: 32,
                    }}
                >
                    {currentTarif === "m" ? "1000" : "1500"} ₽ <span style={{ fontSize: 16, color: color_black }}>{t("в месяц")}</span>
                </OnestBoldDefault>
                <OnestNormalSmall
                    style={{
                        color: color_grey_dark,
                    }}
                >({currentTarif === "m" ? "12000" : "18000"} ₽ {t("в год")})</OnestNormalSmall>
                <Button
                    color={color_white}
                    backgroundColor={color_red_default}
                    height="40px"
                    width={180}
                    onClick={setNewTarif}
                    style={{ borderColor: color_red_default }}
                >
                    {t("Изменить тариф")}
                </Button>
            </div>
           

        </ReactModal>
    );
};

export default ModalTarifChange;